import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import {
  Loader2,
  ChevronLeft,
  ChevronRight,
  Filter,
} from "lucide-react";
import "react-toastify/dist/ReactToastify.css";
import "./ProductLoanReport.css";

const API_URL = "https://payyug.in/api/";

const ProductCollectionReport = () => {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const superAdminId = localStorage.getItem("adminuserId");

  // 1. Fetch Function (Sirf Pagination Backend Se)
  const fetchCollections = useCallback(async () => {
    if (!superAdminId) {
      toast.error("Session expired. Please login again.");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}product-loan/collection-report`, {
        params: {
          superAdminId,
          page: currentPage,
          limit: itemsPerPage,
        },
      });

      if (res.data.success) {
          setCollections(res.data.data || []);
          setTotalPages(res.data.totalPages || 1);
        }
    } catch (err) {
      console.error("Fetch error:", err);
      toast.error("Failed to sync with server.");
    } finally {
      setLoading(false);
    }
  }, [superAdminId, currentPage, itemsPerPage]);

  useEffect(() => {
    fetchCollections();
  }, [fetchCollections]);


const filteredCollections = (collections || []).filter((loan) => {
  if (!searchTerm) return true;

  const search = searchTerm.toLowerCase();
  
  const formNo = loan.formNo ? String(loan.formNo).toLowerCase() : "";
  const name = loan.ref1Name ? String(loan.ref1Name).toLowerCase() : "";
  
  return formNo.includes(search) || name.includes(search);
});


  return (
    <div className="product-loan-report-container">
      <header className="product-loan-report-header">
        <h1 className="product-loan-report-main-title">Product Loan Collection Report</h1>
      </header>

      <section className="product-loan-report-toolbar">
        <div className="product-loan-report-search-container">
          <input
            className="product-loan-report-search-input"
            type="text"
            placeholder="Search by Form No or Name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="product-loan-report-filter-box">

          <select
            className="product-loan-report-filter-select"
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value="10">Show 10</option>
            <option value="25">Show 25</option>
            <option value="50">Show 50</option>
          </select>
        </div>
      </section>

      <div className="product-loan-report-table-wrapper">
        <table className="product-loan-report-table">
          <thead>
            <tr>
              <th>SN</th>
              <th>Account NO</th>
              <th>Customer Id</th>
              <th> Customer Name</th>
                {/* <th>Emi Number</th> */}
                <th>Emi Amount</th>
                <th>Principal Amount</th>
                <th>Interest Amount</th>
                <th>Outstanding</th>
                <th>Paid Amount</th>
                <th>Due Date</th>
                <th>Paid Date</th>
                <th>Remark</th>
                <th>Status</th>
                {/* <th>Reciept</th> */}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="13" className="product-loan-report-loading">
                  <Loader2 className="product-loan-report-loading-spinner" /> Loading...
                </td>
              </tr>
            ) : filteredCollections.length > 0 ? (
              filteredCollections.map((item,index) => (
                <tr key={item.id} className="product-loan-report-table-row">
                  <td>{(currentPage - 1) * 10 + index + 1}</td>
                  <td className="product-loan-report-bold-text">{item?.loan?.formNo||"N/A"}</td>
                  <td className="product-loan-report-bold-text">{item?.customer?.userId||"N/A"}</td>
                  <td className="product-loan-report-bold-text">{item?.customer?.fullName||"N/A"}</td>
                  {/* <td className="product-loan-report-bold-text">{item.emiNumber||"N/A"}</td> */}
                   <td>{`₹${item.emiAmount?.toLocaleString()}`||"N/A"}</td>
                      <td>{`₹${item.principalComponent?.toLocaleString()}`||"N/A"}</td>
                      <td>{`₹${item.interestComponent?.toLocaleString()}`||"N/A"}</td>
                      <td>
                        {`₹${item.outstanding?.toLocaleString()}`||"N/A"}
                      </td>
                      <td>
                        {`₹${item.paidAmount?.toLocaleString()}`||"N/A"}
                      </td>
                      <td>{item.dueDate?new Date(item.dueDate).toLocaleDateString("en-GB"):"N/A"}</td>
                      <td>{item.paymentDate?new Date(item.paymentDate).toLocaleDateString("en-GB"):"N/A"}</td>
                      <td>{item.remark||"N/A"}</td>
                  <td>
                    <span className={`product-loan-report-table-badge product-loan-report-table-badge-approved`}>
                       {item.status}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="13" className="loan-pre-closer-empty">No records found on this page.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <footer className="product-loan-report-pagination">
        <button
          className="product-loan-report-page-btn"
          disabled={currentPage === 1 || loading}
          onClick={() => setCurrentPage((p) => p - 1)}
        >
          <ChevronLeft size={18} />
        </button>
        <span className="product-loan-report-page-info">
          Page <b>{currentPage}</b> of <b>{totalPages}</b>
        </span>
        <button
          className="product-loan-report-page-btn"
          disabled={currentPage >= totalPages || loading}
          onClick={() => setCurrentPage((p) => p + 1)}
        >
          <ChevronRight size={18} />
        </button>
      </footer>

    </div>
  );
};
export default ProductCollectionReport
